import { useAuth } from "@/context/AuthContext";
import { LOGOS } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldAlert } from "lucide-react";

export default function GuestPage() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6" data-testid="guest-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <img src={LOGOS.campus} alt="Campus Connections" className="h-14 w-auto mx-auto object-contain mb-6" />
        <div className="w-14 h-14 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-7 h-7 text-cc-orange" />
        </div>
        <h1 className="text-xl font-semibold text-zinc-900 mb-2">Account not yet set up</h1>
        <p className="text-sm text-zinc-500 leading-relaxed">
          You have not yet been set up as a user on this system. Please get with <strong>Campus Relations</strong> if
          you need a role on this service.
        </p>
        {user?.email && <p className="text-xs text-zinc-400 mt-4">Signed in as {user.email}</p>}
        <Button onClick={logout} className="mt-6 bg-cc-blue text-white" data-testid="guest-logout-btn">
          <LogOut className="w-4 h-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
